import { NgClass } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { SharedModule } from 'primeng/api'
import { ButtonModule } from 'primeng/button'
import { DatePickerModule } from 'primeng/datepicker'
import { InputTextModule } from 'primeng/inputtext'
import { SelectModule } from 'primeng/select'
import { TooltipModule } from 'primeng/tooltip'

import { FieldsModule } from '@app/components/metadata/fields/fields.module'

import { TypeGenericComponent } from './type-generic.component'

@NgModule({
  imports: [
    FormsModule,
    SharedModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    DatePickerModule,
    TooltipModule,
    FieldsModule,
    NgClass,
    TypeGenericComponent,
  ],
  exports: [
    TypeGenericComponent,
  ],
})
export class TypeGenericModule {}
